var TAB = 'Tab';
var ARROW_RIGHT = 'ArrowRight';
var NUMPAD_ENTER = 'NumpadEnter';
var ENTER = 'Enter';
var ARROW_LEFT = 'ArrowLeft';
var ARROW_DOWN = 'ArrowDown';
var ARROW_UP = 'ArrowUp';
var NUMPAD_DECIMAL = 'NumpadDecimal';
var PERIOD = 'Period';
var SPACE = 'Space';
var ESCAPE = 'Escape';
var KEYCODES = {
  TAB: TAB,
  ARROW_RIGHT: ARROW_RIGHT,
  NUMPAD_ENTER: NUMPAD_ENTER,
  ENTER: ENTER,
  ARROW_LEFT: ARROW_LEFT,
  ARROW_DOWN: ARROW_DOWN,
  ARROW_UP: ARROW_UP,
  NUMPAD_DECIMAL: NUMPAD_DECIMAL,
  PERIOD: PERIOD,
  SPACE: SPACE,
  ESCAPE: ESCAPE
};
export default KEYCODES;